import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom/dist';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import UpdateCources from './UpdateCources';
import Notes from '../notes/Notes';
import Students from '../Students/Students';
import Sale from '../Sale/Sale';
const CourcesDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [courseDetails, setCourseDetails] = useState();
  const [loader, setLoader] = useState(false);
  const [tab, setTabs] = useState('details');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState({});
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false); // State for loading

  const [planData, setPlanData] = useState({
    name: '',
    timePeriod: '',
    courseDuration: '',
    file: null,
    description: '',
    price: '',
    lessons: ''
  });

  useEffect(() => {
    fetchCourseDetails(id);
    fetchAdditionalImages(id); // Fetch additional images
  }, [id]);

  const isFormValid = () => {
    return (
      planData.name &&
      planData.timePeriod &&
      planData.courseDuration &&
      planData.file &&
      planData.price &&
      planData.lessons
    );
  };

  const openModal = () => setIsSlipModalOpen(true);
  const closeModal = () => setIsSlipModalOpen(false);

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({
      ...prev,
      file: null
    }));
    setImagePreview(null); // Clear preview image when removed
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPlanData((prev) => ({
        ...prev,
        file: file
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleDeleteClick = () => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    myHeaders.append('Access-Control-Allow-Origin', '*');
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/admin/course/${id}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);

        if (data.success === true) {
          navigate('/cources');
        }

        if (data?.success === false) {
          if (data?.message === 'Expired') {
            localStorage.clear();
            window.location.reload();
            setLoader(false);
          } else {
            setLoader(false);
            toast.error(data?.message);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('DATA', data?.course);
        setCourseDetails(data?.course);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };

  const fetchAdditionalImages = async (id) => {
    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/course-additional-images/${id}`
      );
      const data = await response.json();

      if (data.success) {
        setAdditionalImages(data.additionalImages);
      } else {
        console.error('Failed to fetch additional images');
      }
    } catch (error) {
      console.error('Error fetching additional images:', error);
    }
  };

  const handleAddMoreImages = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setIsUploading(true); // Start Loading

    try {
      const formData = new FormData();
      formData.append('images', file);

      const requestOptions = {
        method: 'POST',
        body: formData
      };

      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.json();

      if (!result.success) {
        toast.error('Error While Upload Images');
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        imageUrl: result?.data[0]
      });

      const updateOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      const updateResponse = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/add-additional-images/${id}`,
        updateOptions
      );
      const updateResult = await updateResponse.text();
      let data = JSON.parse(updateResult);

      if (!data.success) {
        toast.error(data.message);
      } else {
        const newImage = {
          id: Date.now(),
          url: URL.createObjectURL(file),
          name: file.name,
          size: file.size,
          type: file.type
        };

        setAdditionalImages((prev) => [...prev, newImage]);
        window.location.reload();
      }
    } catch (error) {
      console.error('Upload Error:', error);
    } finally {
      setIsUploading(false); // Stop Loading Always
    }
  };

  const handleDeleteImage = async (imageId) => {
    setIsUploading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      imageId: imageId
    });

    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/delete-additional-images/${id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);

        if (data.success === true) {
          window.location.reload();
        } else {
          toast.error("Image Can't Delete At This Moment");
        }
        setIsUploading(false);
      })
      .catch((error) => console.error(error));
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    document.body.style.pointerEvents = 'none';
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    document.body.style.pointerEvents = 'auto';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
  };

  const handleChangeStatus = (newStatus, studentId) => {
    setIsLoading((prevState) => ({
      ...prevState,
      [studentId]: true
    }));

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      newStatus: newStatus
    });

    const requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${studentId}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === true) {
          location.reload();
        } else {
          toast.error('Status Not Changed');
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setIsLoading((prevState) => ({
          ...prevState,
          [studentId]: false // Reset the loading state after the request
        }));
      });
  };

  const ApproveFee = (link) => {
    setIsModelLoading(true); // Start loading

    // console.log("LINK", link?._id);
    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === false) {
          toast.error(data?.error);
          setIsModelLoading(false);
        }
        setIsModelLoading(false);
        toast.success('Fee is Paid');
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error);
        setIsModelLoading(false);
      });
  };
  const [updateCources, setUpdateCources] = useState(false);
  const [single, setSingle] = useState({});
  return (
    <Wrapper>
      <UpdateCources
        setIsModalOpen={setUpdateCources}
        isModalOpen={updateCources}
        getData={single}
      />
      <h2 className="main_title ">{courseDetails?.name}</h2>
      <p className=" text-[#1C1D1D]">Here are details of your courses</p>
      <div>
        <ul className=" mt-6 flex w-full gap-4 border-b">
          <li className=" cursor-pointer" onClick={() => setTabs('details')}>
            <span
              className={` ${
                tab === 'details' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Details
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('student')}>
            <span
              className={` ${
                tab === 'student' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Students
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('documents')}>
            <span
              className={` ${
                tab === 'documents' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Documents
            </span>
          </li>
          <li className="cursor-pointer" onClick={() => setTabs('sale')}>
            <span
              className={` ${
                tab === 'sale' ? 'text-[#FF7E00] border-b-2 border-[#FF7E00]' : 'text-gray-400'
              } `}
            >
              Sale
            </span>
          </li>
        </ul>
      </div>

      {tab === 'details' ? (
        <section>
          <div className=" flex justify-between  py-3 items-center">
            <div className="">
              <p className=" text-lg m-0">Cource Details</p>
            </div>
            {loader === true ? <Loader /> : null}

            <div className=" flex items-center gap-3">
              <img
                src={require('../../assets/image/edit.png')}
                onClick={() => {
                  setUpdateCources(true);
                  setSingle(courseDetails);
                }}
                alt="Delete"
                style={{ cursor: 'pointer' }}
              />
              {/* <img
                src={require('../../assets/image/del.png')}
                onClick={handleDeleteClick}
                alt="Delete"
                style={{ cursor: 'pointer' }}
              /> */}
            </div>
          </div>

          <div className=" p-3 rounded-lg" style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}>
            <span className=" m-0 text-gray-400 text-sm">Cource Name</span>
            <h6 className=" text-lg">{courseDetails?.name}</h6>

            <span className=" pt-3 m-0 text-gray-400 text-sm">Description</span>
            <h6 className="">{courseDetails?.description}</h6>
            <ul className=" flex flex-col gap-2 mt-5">
              <li>
                <span className=" m-0 text-gray-400 text-sm">Price</span>
                <p>$ {courseDetails?.price}</p>
              </li>
              <li>
                <span className=" m-0 text-gray-400 text-sm">Lessons</span>
                <p>{courseDetails?.lesson}</p>
              </li>
              <li>
                <span className=" m-0 text-gray-400 text-sm">Duration</span>
                <p>
                  {courseDetails?.duration} {courseDetails?.periodType}
                </p>
              </li>
            </ul>
            <div className="mt-6">
              <h3 className="text-lg font-bold">Additional Images</h3>
              <div className="grid grid-cols-3 gap-4 mt-4">
                {additionalImages.length > 0 ? (
                  additionalImages.map((image) => (
                    <div key={image.id} className="relative">
                      <img
                        src={image.url}
                        alt={image.name}
                        className="w-full h-60 object-cover rounded-md"
                      />
                      <button
                        onClick={() => handleDeleteImage(image._id)}
                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 text-xs"
                      >
                        ✕
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No additional images available.</p>
                )}
              </div>

              {/* Button to trigger file input */}
              <button
                onClick={() => document.getElementById('fileInput').click()} // Trigger file input
                disabled={isUploading} // Disable when uploading
                className={`bg-blue-500 text-white mt-5 px-4 py-2 rounded ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isUploading ? 'Loading...' : 'Upload Image'}
              </button>
              <input id="fileInput" type="file" onChange={handleAddMoreImages} className="hidden" />
            </div>
          </div>

          {isModalOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
              style={{ pointerEvents: 'auto', userSelect: 'none' }}
            >
              <div
                className="bg-white p-6 rounded-lg w-[70%] max-h-[90vh] overflow-y-auto relative"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={handleCloseModal}
                  className="absolute top-2 right-2 text-2xl font-bold cursor-pointer"
                >
                  &times;
                </button>

                <h2 className="main_title ">Edit Course</h2>
                <form onSubmit={bannerSubmit}>
                  <div className="flex gap-5 flex-wrap">
                    <div className="w-[100%]">
                      <Input
                        label={'Course Name'}
                        placeholder={'nme'}
                        className={'bg-gray-100 px-2 w-full'}
                        name="name"
                        value="Sex"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="w-[48%]">
                      <label className="block mb-2 text-sm text-gray-900 font-medium">
                        Duration
                      </label>
                      <select
                        name="courseDuration"
                        value={planData.courseDuration}
                        onChange={handleChange}
                        className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                      >
                        <option>Select Duration</option>
                        {[...Array(12).keys()].map((i) => (
                          <option key={i} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="w-[48%]">
                      <label className="block mb-2 text-sm text-gray-900 font-medium">
                        Period Type
                      </label>
                      <select
                        name="timePeriod"
                        value={planData.timePeriod}
                        onChange={handleChange}
                        className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                      >
                        <option>Select Type</option>
                        <option value="month">Month</option>
                        <option value="year">Year</option>
                      </select>
                    </div>

                    <div className="w-[100%]">
                      <Input
                        label={'Lessons'}
                        placeholder={'Enter number of lessons'}
                        className={'bg-gray-100 px-2 w-full'}
                        name="lessons"
                        value={planData.lessons}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="w-[100%]">
                      <Input
                        label={'Price'}
                        placeholder={'Enter price'}
                        className={'bg-gray-100 px-2 w-full'}
                        name="price"
                        value={planData.price}
                        onChange={handleChange}
                        type="number"
                      />
                    </div>

                    <div className="w-[100%]">
                      <label>Description</label>
                      <textarea
                        rows={6}
                        className="w-full bg-[#F6F6F6] py-3 px-5"
                        name="description"
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    <div
                      className="w-full border-dashed border-[#9E9E9E] bg-[#F6F6F6] border-2 rounded-lg p-4 cursor-pointer"
                      onClick={handleClick}
                    >
                      <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-20 rounded-2xl">
                        <MdOutlineFileUpload size={30} className="text-primary" />
                      </div>
                      <p className="text-primary font-medium mt-3 text-center">
                        <span className="text-secondary">Click here</span> to upload or drop CNIC
                      </p>

                      {imagePreview && (
                        <div className="relative w-full h-32 mt-4">
                          <img
                            src={imagePreview}
                            alt="Selected Image"
                            className="w-full h-full object-cover rounded-md"
                          />
                          <button
                            type="button"
                            onClick={handleRemoveImage}
                            className="absolute top-0 right-0 bg-red-500 text-white p-2 rounded-full"
                          >
                            <MdClose size={20} />
                          </button>
                        </div>
                      )}
                      <input
                        id="fileInput"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                      />
                    </div>
                    {loading ? (
                      <button
                        disabled
                        type="button"
                        className="bg-primary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
                      >
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className={`w-full mt-3 bg-primary py-2.5 rounded-md text-white text-sm font-medium ${
                          !isFormValid() && 'cursor-not-allowed opacity-50'
                        }`}
                        disabled={!isFormValid()}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}
        </section>
      ) : tab === 'student' ? (
        <Students />
      ) : tab === 'sale' ? (
        <Sale />
      ) : (
        <Notes />
      )}
    </Wrapper>
  );
};

export default CourcesDetails;
